import { getToken } from "@/shared/lib/token";

/** Claims do access token emitido pelo auth-api que o front usa para decidir a UI. */
interface TokenClaims {
    sub?: string;
    exp?: number;
    tenantId?: string;
    platformAdmin?: boolean;
    /** Presente só em sessões de suporte: `sub` é o admin da plataforma. */
    act?: { sub?: string };
}

function decodeTokenClaims(token: string | null | undefined): TokenClaims | null {
    if (!token) return null;

    try {
        const payloadBase64 = token.split(".")[1];
        if (!payloadBase64) return null;
        const payloadJson = atob(payloadBase64.replace(/-/g, "+").replace(/_/g, "/"));
        const payload: unknown = JSON.parse(payloadJson);
        return payload && typeof payload === "object" ? (payload as TokenClaims) : null;
    } catch {
        return null;
    }
}

function getTokenClaims(): TokenClaims | null {
    return decodeTokenClaims(getToken());
}

/** Claim do auth-api para a equipa da 7Days; sessões de suporte (`act`) não contam. */
export function hasPlatformAdminClaim(): boolean {
    const claims = getTokenClaims();
    return claims?.platformAdmin === true && claims.act === undefined;
}
